<template>
  <div>
    <b-card
      no-body
      border-variant="msstream"
      class="marginal"
    >

      <b-card-header
        header-bg-variant="msstream"
        header-text-variant="white"
        class="text-center"
      >
        <h6 class="m-0">
          <b-row class="align-items-center justify-content-center">
          <font-awesome-icon icon="user-tie" />&nbsp;
            {{$ml.get('collab')}}
          &nbsp;<b-badge variant="light">{{users.length}}</b-badge>
          </b-row>
        </h6>
      </b-card-header>
      
      <b-card-body class="small">
        <b-table
          show-empty
          centered
          responsive
          striped
          bordered
          :items="users"
          :fields="managerTable"
        >
          <template v-slot:cell(username)="row">
            <b-row class="justify-content-between align-items-center mr-2 ml-2  ">
              <div style="word-break:break-word; max-width:250px; margin:10px 0px">{{ row.item.username }}</div>
              <b-button
              size="sm"
              variant="darkblue"
              v-if="row.item.username !== myUser.username"
              @click="
                  userSelected = row.item.username;
                  OpenChatUser();
              "
              >
                <font-awesome-icon :icon="['fas', 'comments']" />
                Chat
              </b-button>
            </b-row>
          </template>

          <template v-slot:cell(isManager)="row">
            <b-form-checkbox 
              v-model="row.item._isManager"
              switch
              size="sm"
              :disabled="(row.item.username === $auth.getMyUser().username) || ($auth.getRoles().indexOf('manager') === -1)"
              @input="updateUserRole(row.item)"
            >
                {{ row.item._isManager ? "Account Manager" : "" }}
            </b-form-checkbox>
          </template>
          <!--<template v-slot:cell(isEditor)="row">
          <b-form-checkbox
              v-model="row.item._isEditor"
              switch
              :disabled="(row.item._isManager) || ($auth.getRoles().indexOf('manager') === -1)"
              @input="updateUserRole(row.item)"
          >
              {{ row.item._isEditor ? "Videos manager" : "" }}
          </b-form-checkbox>
          </template>-->

          <template v-slot:cell(roles)="row">
            <b-btn 
            variant="mswarning"                       
            size="sm"
            @click="
              userSelected = row.item.username;
              openPrivileges();
              showModal('newRoles');
            "
            :disabled="($auth.getRoles().indexOf('manager') === -1 && (row.item.username !== $auth.getMyUser().username))">
              <b-icon icon="pencil-square"/> {{$ml.get('edit')}}
            </b-btn>
          </template>

          <template v-slot:cell(remove)="row">
            <b-button
              variant="quanteec"
              size="sm"
              @click="
              userSelected = row.item.username;
              showModal('confirmDelete');
              "
              v-if="$auth.getRoles().indexOf('manager') > -1 && (row.item.username !== $auth.getMyUser().username)"
              >
              <b-icon icon="person-x-fill" />
              {{$ml.get('delete')}} 
            </b-button>
          </template>
        </b-table>

        <b-row v-if="$auth.getMyUser().roles.indexOf('manager') > -1" class="justify-content-center">
            <b-col style="padding: 0.2rem; text-align: center">
              <b-button 
                class="col-md-5 col-12"
                size="sm"
                variant="msstreamblue" 
                style="padding:6px"
                v-b-modal.newUser
              >
                <b-icon icon="person-plus-fill" />
                {{$ml.get('createcollab')}}
              </b-button>
            </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-modal 
      hide-footer 
      id="newUser"
      :title="$ml.get('newcollab')"
    >
      <UserForm v-on:userCreated="userCreated()" v-on:closeUserCreated="closeModalUserCreated()"></UserForm>
    </b-modal>

    <b-modal hide-footer 
      ref="newRoles"
      title="Privileges"
    >
      <b-form @submit.prevent="onSubmitPrivileges()">
        <b-table-simple class="small">
          <b-thead head-variant="dark">
            <b-tr>
              <b-th>{{$ml.get('category')}}</b-th>
              <b-th style="text-align:center">{{$ml.get('read')}}</b-th>
              <b-th style="text-align:center">{{$ml.get('update')}}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-th><b-icon icon="graph-up"/> Analytics</b-th>
              <b-td style="text-align:center"><input v-model="privileges.readAnalytics" type="checkbox" id="analyticsPrivilege" :disabled="privileges.disabled"></b-td>
              <b-td style="text-align:center"></b-td>
            </b-tr>
            <b-tr>
              <b-th><b-icon icon="play-btn"/> Videos</b-th>
              <b-td style="text-align:center"><input v-model="privileges.readVideos" type="checkbox" id="getVideos" :disabled="privileges.modifyVideos || privileges.disabled"></b-td>
              <b-td style="text-align:center"><input v-model="privileges.modifyVideos" @change="changeModifyVideos" type="checkbox" id="modifyVideos" :disabled="privileges.disabled"></b-td>
            </b-tr>
            <b-tr>
              <b-th><b-icon icon="gear-fill"/> Configs</b-th>
              <b-td style="text-align:center"><input v-model="privileges.readConfigurations" type="checkbox" id="getConfigs" :disabled="privileges.modifyConfigurations|| privileges.disabled"></b-td>
              <b-td style="text-align:center"><input v-model="privileges.modifyConfigurations" @change="changeModifyConfigs" type="checkbox" id="modifyConfig" :disabled="privileges.disabled"></b-td>
            </b-tr>
          </b-tbody>
          <!--<b-tfoot>
            <b-tr>
              <b-td colspan="7" variant="secondary" class="text-right">
                Total Rows: <b>5</b>
              </b-td>
            </b-tr>
          </b-tfoot>-->
        </b-table-simple>
        <hr/>
        <b-row class="justify-content-center">
          <div class="form-group small align-items-center">
            <label for="getAllConfigs">{{$ml.get('accessall')}} [<b-icon icon="gear-fill"/> Configs]</label>
            &nbsp;
            <input v-model="privileges.getAllConfigs" type="checkbox" id="getAllConfigs" :disabled="privileges.disabled">
          </div>
        </b-row>

        <div v-if="!privileges.getAllConfigs" class="small">
          <b-row class="justify-content-center">
            <p>{{$ml.get('limitacc')}} [<b-icon icon="gear-fill"/> Configs]:</p>
          </b-row>
          <div class="form-group">
            <b-row class="justify-content-center">
              <b-col cols="6">
                <b-select :options="options" size="sm" v-model="selectedConfig"></b-select>
              </b-col>
              <b-col cols="auto">
                <b-btn variant="msstreamblue" size="sm" @click="pushConfigToLimits()"><b-icon icon="plus-circle" /> {{$ml.get('add')}}</b-btn>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col cols="auto" class="mt-2 mb-4" v-for="(conf, idx) in privileges.limitConfigs" v-bind:key="idx">
                {{conf.text}}
                <b-icon style="cursor:pointer" @click="privileges.limitConfigs.splice(idx, 1)" icon="x-circle" color="red" />
            </b-col>
          </b-row>
        </div>

        <hr/>

        <b-row class="justify-content-center">
            <b-col cols="auto" v-if="!privileges.disabled">
                <b-btn size="sm" type="submit" variant="msstreamblue" :disabled="privileges.disabled">
                  <b-icon icon="check2-circle" />
                  {{$ml.get('submit')}}
                </b-btn>
            </b-col>
        </b-row>
          
      </b-form>
    </b-modal>
    
    <b-modal ref="confirmDelete" hide-footer :title="$ml.get('collabdel')" >
        <small style="line-height:normal">{{$ml.get('confirmcollabdel')}} <strong><span style="color: #2F90B0; word-break:break-word">{{userSelected}}</span></strong>.<br>{{$ml.get('norecover')}} </small>
        <hr />
        <b-row class="justify-content-around mt-3">
            <b-btn size="sm" class="col-md-3 col-5" variant="quanteec" @click="removeUser(userSelected);hideModal('confirmDelete')">
              <font-awesome-icon style="margin-right:5px" :icon="['fas', 'user-times']" />
              {{$ml.get('delete')}}
            </b-btn>
        </b-row> 
    </b-modal>
  </div>
</template>

<script>
import UserForm from "@/components/UserForm.vue";
import ConfigurationService from '@/services/configuration.service.js';
import UserService from "@/services/user.service";

let configService = new ConfigurationService();
let userService = new UserService();

export default {
  name: "RolesPage",
  components: {
    UserForm
  },
  data() {
    return {
        userSelected: null,
        managerTable: [],
        privileges: {
            
        },
        myUser: this.$auth.getMyUser(),
        clientView: this.$auth.getMyUser().roles.indexOf("admin") > -1
            ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
            : this.$auth.getMyUser().client,
        clientViewObject: this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientViewObject() || this.$auth.getMyUser().client_infos[0]
          : this.$auth.getMyUser().client_infos[0],
        users: [],
        managerTable: [
            { key: "username", label: "Username", sortable: true, thClass: 'text-center', tdClass: 'align-middle' },
            { key: "email", label: "Email", thClass: 'text-center', tdClass: 'align-middle' },
            { key: "isManager", label: "Account Manager", thClass: 'text-center', tdClass: 'align-middle' },
            //{ key: "isEditor", label: "Videos Manager", thClass: 'text-center', tdClass: 'align-middle' },
            { key: "roles", label: "Privileges", thClass: 'text-center', tdClass: 'align-middle, text-center' },
            { key: "remove", label: "", thClass: 'text-center', tdClass: 'align-middle, text-center' },
        ],
        options: [],
        selectedConfig: null
    }
  },
  mounted() {
    this.getAllUsers();
    this.getConfigurations();
  },
  methods: {
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    changeModifyConfigs() {
        if (this.privileges.modifyConfigs) {
            this.privileges.readConfigs = true;
        }
    },
    changeModifyVideos() {
      if (this.privileges.modifyVideos) {
            this.privileges.readVideos = true;
        }
    },
    getConfigurations() {
        configService.getConfigurations({filter:JSON.stringify({client: this.clientView})}, this.$auth.token()).then(configurations => {
            configurations._embedded.sort((a,b) => a.name.localeCompare(b.name));
            this.options = configurations._embedded.map(x => { return { value: x.key, text: x.name } });
            if (this.selectedConfig === null) {
                this.selectedConfig = this.options[0].value
            }
      }).catch(err => {
        console.log(err);
      })
    },
    resetPrivileges() {
        this.privileges = {
            readAnalytics: false,
            readVideos: false,
            modifyVideos: false,
            readConfigurations: false,
            modifyConfigurations: false,
            getAllConfigs: true,
            limitConfigs: []
        }
    },
    openPrivileges() {
      let user = this.users.find(x => x.username === this.userSelected)
      this.resetPrivileges();
      if (user !== null && user.roles && user.roles.length >= 0) {
        if (user.roles.indexOf('manager') > -1) {
          this.privileges.readVideos = true;
          this.privileges.modifyVideos = true;
          this.privileges.readConfigurations = true;
          this.privileges.modifyConfigurations = true;
          this.privileges.readAnalytics = true;
          this.privileges.getAllConfigs = true;
          this.privileges.disabled = true;
          this.privileges.limitConfigs = [];
        } else {
          user.roles.forEach(role => {
              this.privileges[role] = true;
          })
          if (user.access && user.access.length > 0) {
            this.privileges.getAllConfigs = false;
            this.privileges.limitConfigs = user.access.map(x => {return this.options.find(y => y.value === x)});
          }
          if (!this.$auth.validateRoles(['manager'])) {
            this.privileges.disabled = true;
          }
        }
      }
    },
    pushConfigToLimits() {
        if (this.privileges.limitConfigs.findIndex(x => x.value === this.selectedConfig) === -1) {
            this.privileges.limitConfigs.push(this.options.find(x => x.value === this.selectedConfig))
        }
    },
    OpenChatUser() {
      var url = "#/chat/singleConv/" + this.userSelected;
      window.open(url, this.userSelected, "width=1200, height=750");
    },
    userCreated() {
      //TO-DO Fermer la modale de création et recharger la liste des utilisateurs.
      this.getAllUsers();
    },
    closeModalUserCreated() {
      this.$bvModal.hide("newUser");
    },
    updateUserRole(user) {
      var userData = {
        roles: [],
      };
      if (user._isManager) {
        userData.roles.push("manager");
        userData.roles.push("editor");
      }
      if (user._isEditor) {
        userData.roles.push("editor");
      }
      userService
        .putUser(user.username, userData, this.$auth.token())
        .then((user) => {
          this.getAllUsers();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllUsers() {
      userService.getUsers(this.$auth.token()).then((data) => {
        var users = data;
        this.users = users;
        this.users.forEach(function (elem) {
          if (elem.roles) {
            if (elem.roles.indexOf("editor") > -1) {
              elem._isEditor = true;
            } else {
              elem._isEditor = false;
            }
            if (elem.roles.indexOf("manager") > -1) {
              elem._isManager = true;
              elem._isEditor = true;
            } else {
              elem._isManager = false;
            }
          }
        });
        this.optionsUser = users.map((elem) => elem.username).sort();
      });
    },
    getMyUser() {
      if (this.$auth.getMyUser().roles.indexOf("admin") === -1) {
        userService
          .getMyUser(this.$auth.token())
          .then((user) => {
            this.$auth.setMyUser(user);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        userService
          .getUser(this.$auth.token(), this.clientView)
          .then((user) => {
            clientService.getClient(this.clientView, this.$auth.token()).then(client => {
              this.clientMy = { ...tableDefault, ...client };
              this.$auth.loadClientViewObject().catch(err=> {})
            }).catch(err => {})
            this.$auth.setMyClientView(user.client);

          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    removeUser(username) {
      userService
        .deleteUserById(username, this.$auth.token())
        .then((client) => {
          this.getAllUsers();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSubmitPrivileges() {
      let roles = [];
      let access = [];
      if (this.privileges.readVideos) {
        roles.push('readVideos');
      }
      if (this.privileges.readAnalytics) {
        roles.push('readAnalytics');
      }
      if (this.privileges.modifyVideos) {
        roles.push('modifyVideos');
      }
      if (this.privileges.readConfigurations) {
        roles.push('readConfigurations');
      }
      if (this.privileges.modifyConfigurations) {
        roles.push('modifyConfigurations');
      }
      let user = this.users.find(x => x.username === this.userSelected)
      if (user !== null && user.roles && user.roles.length > 0 && user.roles.indexOf("manager") > -1) {
        roles.push('manager');
        access = [];
      }
      if (!this.privileges.getAllConfigs) {
        access = this.privileges.limitConfigs.map(x => x.value)
      }

        userService.putUser(this.userSelected, {roles: roles, access: access}, this.$auth.token())
        .then((user) => {
           this.getAllUsers();
           this.getMyUser();
           this.hideModal('newRoles');
        }).catch(err => {
          console.log(err);
          window.alert("Can not update user roles. Please retry later.")
        })
    }
  }
}
</script>

<style scoped>

</style>
